const walkObj = (obj, fn, path = [], all = false) => {
  const exit = fn(path.slice(), obj)
  if (exit === true) return obj

  let index = 0
  if (Array.isArray(obj)) {
    for (let item of obj) {
      if (item && typeof item === 'object') walkObj(item, fn, [...path, index])
      index++
    }
  } else if (obj && typeof obj === 'object') {
    for (let key in obj) {
      if (all) walkObj(obj[key], fn, [...path, key])
      else if (obj[key] && typeof obj[key] === 'object') walkObj(obj[key], fn, [...path, key])
    }
  }
  return obj
}

module.exports = walkObj
